import { render, staticRenderFns } from "./editPreInfoCar.vue?vue&type=template&id=67860823&"
import script from "./editPreInfoCar.vue?vue&type=script&lang=js&"
export * from "./editPreInfoCar.vue?vue&type=script&lang=js&"
import style0 from "./editPreInfoCar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports